import PropTypes from 'prop-types';
import React from 'react';
import InputField from '../inputs/InputField';
import { connect } from 'react-redux';
import { matrixOtherChange, matrixOtherBlur } from './actions';
import { questionKey } from '../response/reducer';

const MatrixRowOther = ({
  disabled,
  isValid,
  onBlur,
  onChange,
  questionId,
  questionName,
  value,
}) => (
  <InputField
    className="input-block-level"
    disabled={disabled}
    isValid={isValid}
    name={`questions[${questionName}-other-value]`}
    onBlur={onBlur}
    onChange={onChange}
    placeholder="Please specify"
    questionId={questionId}
    type="text"
    value={value}
  />
);

MatrixRowOther.propTypes = {
  disabled: PropTypes.bool,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  isValid: PropTypes.bool,
  questionId: PropTypes.string.isRequired,
  questionName: PropTypes.string.isRequired,
  value: PropTypes.string,
};

MatrixRowOther.defaultProps = {
  isValid: true,
};

const mapStateToProps = (state, ownProps) => {
  const question = state[questionKey(ownProps)];
  return {
    disabled: question.none,
    isValid: !!question.isOtherValid,
    value: question.none ? '' : question.otherValue,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onChange: e =>
    dispatch(matrixOtherChange(e.target.value, ownProps.questionId)),
  onBlur: () => dispatch(matrixOtherBlur(ownProps.questionId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MatrixRowOther);
